<template>
  <div>
    <main>
      <div class="WorkM_MainArea">
        <b-container fluid>
          <div class="WorkM_ProxyApplicationTitleArea">
            <div class="TitleItem_TitleLabel"><b-icon icon="people" class="mr-2"></b-icon>代理申請設定/解除</div>
          </div>
          <div class="ProxyApplicationMainArea">
            <!-- 検索条件 -->
            <div class="ProxyApplicationConditionArea">
              <div class="ConditionRow d-flex">
                <div class="ConditionEachArea">
                    <div class="EachRow d-flex mb-2 align-items-center">
                        <label class="labelTitle pt-0 pl-2">本社/支店</label>
                        <b-select class="selectSectionPart" :options="optionOffice_group" v-model="selectOffice" @change="getAttendanceListOffice()" :items="optionOffice" value-field="office_code" text-field="office_name"></b-select>
                        <label class="labelTitle pt-0 pl-2">部</label>
                        <b-select class="selectSectionPart" :options="optionPart_group" v-model="selectPart" @change="getAttendanceListPart()" :items="optionPart" value-field="key" text-field="part_name"></b-select>
                        <label class="labelTitle pt-0 pl-2">課</label>
                        <b-select class="selectSectionPart" :options="optionSection_group" v-model="selectSection" @change="getAttendanceListSection()" :items="optionSection" value-field="key" text-field="section_name"></b-select>
                    </div>
                </div>
              </div>
            </div>
            <!-- 一覧 -->
            <div class="ProxyApplicationListArea small">
            </div>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>
<script>
//import config from "../../const/config";
export default {
  name: "Manager_ProxyApplication",
  components: {},
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  mounted: function () {
  },
  methods: {
  }
};
</script>
<style>

.WorkM_MainArea {
  padding: 0 1rem;
  min-height: 450px; 
}
.ProxyApplicationConditionArea {
  padding: 1rem;
  /* margin-bottom: 0.5rem; */
  border-top: 1px solid rgb(82, 75, 75);
  border-bottom: 1px solid rgb(82, 75, 75);
}
.ProxyApplicationListArea {
  /*
  border: 1px dashed #abcdef;
  */
  max-height: 675px;
  border-bottom: 1px solid rgb(212, 212, 212);
  overflow-y: auto;
  /* margin-top: 1rem; */
  padding-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
}
/* .WorkM_AttendanceCheckHeader {
    position: sticky;
    top: 0;
    z-index: 999;
} */
.WorkM_ChangeTargetDateArea {
    justify-content: space-around;
    width: 100%;
    text-align: center;
    background: #ececec;
    border-bottom: 1px solid rgb(241, 241, 241);
    padding: 0.3rem;
    padding-right: 1rem;
    padding-left: 2rem;
    font-size: 1.2rem;
}
.WorkM_SelectPart {
    width: 10rem;
}
.WorkM_SelectSection{
    width: 10rem;
}
.WorkM_ChangeTargetSelect{
    background-color: #f8f8f8;
    font-size: 0.8rem;
}

.WorkM_AttendanceList{
    background: rgb(248, 248, 248);
    border-radius: 5px;
    font-size: 0.9rem;
    height: 2rem;
}
.workerStatus{
    display: flex;
    align-items: left;
    min-width: 2rem;
    height: 100%;
}
.WorkM_ManagerAttendanceCheck{
    background: transparent;
    /* overflow-y: auto;
    max-height: 300px; */
    max-width: initial !important;
    margin-left: auto;
    margin-right: auto;
}
.managerWorkerRest{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    color: rgb(241, 241, 241);
    background: rgb(207, 90, 90);
    height: 100%;
    width: 100%;
}
.managerWorkerRestColor{
    /* border: 1px solid rgb(207, 90, 90); */
    background-color: rgb(255, 214, 214);
}
.managerWorkerRestColor_Type1{
    border: 1px solid rgb(207, 90, 90);
}
.workerWork{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 0 0 5px;
    color: rgb(241, 241, 241);
    background: rgb(40, 123, 201);
    height: 100%;
    width: 100%;
}
.managerWorkerWorkColor{
    /* border: 1px solid rgb(40, 123, 201); */
    background-color: rgb(214, 247, 255);
}
.managerWorkerWorkColor_Type1{
    border: 1px solid rgb(40, 123, 201);
}
/* .workerName{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-right: 2rem; 
} */
.managerWorkerName{
    width: 100%;
    margin-right: auto;
    margin-left: 2rem;
    margin-top: auto;
    margin-bottom: auto;
}
.managerWorkerNamePartialRest{
    width: 100%;
    margin-right: auto;
    margin-left: 3rem;
    margin-top: auto;
    margin-bottom: auto;
}
.attendanceWorkerName{
    width: 100%;
    /* workerStatusに合わせる */
    margin-top: auto;
    margin-bottom: auto;
}
.AttendanceCheckItem{
    width: 10rem;
}
.selectSectionPart{
    width: 189px !important;
    /* 年月日入力欄に合わせる */
}
.inputManagerAttendanceCheckDateTime{
    height: 42.5px !important;
    /* 部・課選択欄に合わせる */
}
</style>
